import { toLabelValue } from '@/common/convertToDropdownOptions';
import { Spinner } from '@/components/Spinner';
import { useGetAdminPlanDetail } from '../hooks/useGetAdminPlanDetails';
import { useGetTimeInterval } from '../hooks/useGetTimeInterval';
import AdminPlanFormView from './AdminPlanFormView';

const AdminPlanForm = ({ clubId, planId = '' }: { clubId: string; planId?: string }) => {
  const { adminPlanDetails, isLoading } = useGetAdminPlanDetail(clubId, planId);
  const { data = [], isLoading: isLoadingTimeInterval } = useGetTimeInterval(clubId);
  const lastEntryTimeOptions = toLabelValue(data, {
    labelKey: 'timeInterval',
    valueKey: 'timeInterval',
  });

  const defaultValues = {
    lastEntryTime: adminPlanDetails?.lastEntryTime || 'default',
    noOfPeople: String(adminPlanDetails?.noOfPeople) || 'default',
    planName: adminPlanDetails?.planName ?? '',
    planNameEnglish: adminPlanDetails?.planNameEnglish ?? '',
  };
  if (isLoading || isLoadingTimeInterval) return <Spinner />;
  return (
    <AdminPlanFormView
      clubId={clubId}
      planId={planId}
      defaultValues={defaultValues}
      lastEntryTimeOptions={lastEntryTimeOptions}
    />
  );
};

export default AdminPlanForm;
